import { render } from "./recoverPasswordComponent.vue?vue&type=template&id=5fe1acd6"
import script from "./recoverPasswordComponent.vue?vue&type=script&lang=js"
export * from "./recoverPasswordComponent.vue?vue&type=script&lang=js"

import "./recoverPasswordComponent.vue?vue&type=style&index=0&id=5fe1acd6&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__